import { SGService } from "./implementations/sg.service.js";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default defineNuxtPlugin((nuxtApp) => {
  const sg = new SGService(
    nuxtApp, 
    nuxtApp.$axios, 
    nuxtApp.$config.public.sgCmsApi, 
    nuxtApp.$config.public.sgApiUrl,
    useStore(),
    useRoute(),
    useRouter()
  );

  return {
    provide: {
      sg: sg,
    },
  };
});
